<template>
  <div class="telegram_modal">
    <div class="header">
      <h4 class="title">{{ translate('telegram.' + mode) }}</h4>
    </div>
    <div class="block">
      <template v-if="mode === 'create'">
        <div class="line row">
          <div class="col-md-12 col-sm-12">
            <fg-input
                v-model="destination.name"
                type="text"
                :label="translate('telegram.name')"
                :disabled="saving"
            />
          </div>
        </div>
        <div class="line row">
          <div class="col-md-12 col-sm-12">
            <fg-input
                v-model="destination.chat_id"
                type="text"
                :label="translate('telegram.chat_id')"
                :disabled="saving"
            />
          </div>
        </div>
        <div class="line row">
          <div class="col-md-12 col-sm-12">
            <fg-input
                v-model="destination.thread_id"
                type="text"
                :label="translate('telegram.thread_id')"
                :disabled="saving"
            />
          </div>
        </div>
        <div class="form-group">
          <label>{{ translate('telegram.recipient') }}</label>
          <tree-select
            v-model="destination.client_id"
            :options="clients"
            :clearable="false"
            :disabled="saving"
          />
        </div>
      </template>
      <template v-else>
        <fg-input
          :value="channel.name"
          :label="translate('telegram.name')"
          :readonly="true"
        />
        <fg-input
          :value="channel.chat_id"
          label="Chat ID"
          :readonly="true"
        />
        <fg-input
          :value="channel.thread_id || translate('telegram.no_thread')"
          label="Thread ID"
          :readonly="true"
        />
        <p>{{ translate('telegram.recipient') }}: {{ recipient }}</p>
        <p v-if="mode === 'disable'">{{ translate('telegram.disable_warning') }}</p>
        <template v-else>
          <p
            v-if="channel.client_id"
            class="text-warning"
          >
            {{ translate('telegram.client_warning') }}
          </p>
          <p>{{ translate('telegram.test_hint') }}</p>
        </template>
      </template>
      <p
        class="text-success"
        v-if="success"
      >
        {{ success }}
      </p>
      <div class="bottoms">
        <button
          v-if="!success"
          class="btn btn-fill btn-wd"
          :class="mode === 'disable' ? 'btn-danger' : 'btn-success'"
          :disabled="saving"
          @click.prevent="save_destination"
        >
          {{ translate('telegram.' + (mode === 'test' ? 'send_test' : mode)) }}
        </button>
        <button
          class="btn btn-info btn-fill btn-wd"
          :disabled="saving"
          @click.prevent="close"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TelegramDestinationModal',
  props: ['mode', 'channel', 'clients', 'recipient'],
  data () {
    return {
      destination: {name: '', chat_id: '', thread_id: '', client_id: 0},
      success: '',
      saving: false
    }
  },
  methods: {
    save_destination() {
      if (this.saving) return
      let params
      if (this.mode === 'create') {
        params = {
          name: this.destination.name.trim(),
          chat_id: this.destination.chat_id.trim(),
          thread_id: this.destination.thread_id.trim() || null,
          client_id: this.destination.client_id || null
        }
        if (!params.name) {
          this.global_notify('danger', this.translate('telegram.required'))
          return
        }
        if (!/^-?\d+$/.test(params.chat_id) || /^-?0+$/.test(params.chat_id)) {
          this.global_notify('danger', this.translate('telegram.invalid_chat'))
          return
        }
        if (params.thread_id !== null && (!/^\d+$/.test(params.thread_id) || /^0+$/.test(params.thread_id))) {
          this.global_notify('danger', this.translate('telegram.invalid_thread'))
          return
        }
      }
      this.saving = true
      switch (this.mode) {
        case 'create':
          this.$http.v1.createTelegramDestination(params, () => {
            this.$emit('update')
            this.$emit('close')
          }).finally(() => {
            this.saving = false
          })
          break;
        case 'disable':
          this.$http.v1.disableTelegramDestination(this.channel.id, () => {
            this.$emit('update')
            this.$emit('close')
          }).finally(() => {
            this.saving = false
          })
          break;
        case 'test':
          this.$http.v1.testTelegramDestination(this.channel.id, () => {
            this.success = this.translate('telegram.queued')
          }).finally(() => {
            this.saving = false
          })
          break;
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.telegram_modal {
  height: 100%;
  padding: 10px;
  .header {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    .title {
      width: 100%;
      margin: 0;
      text-align: center;
    }
  }
  .block {
    text-align: left;
  }
  .form-group {
    margin-bottom: 10px;
  }
  .bottoms {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
}
</style>
